import { Component, Input, OnChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { UitnodigingDto } from 'parkour-web-app-dto';
import { AsyncPipe } from '@angular/common';
import { ProfielDetailsComponent } from '../../../profiel/component/profile-details/profiel-details.component';
import { TeamService } from '../../service/team.service';
import { TeamlidProfiel } from '../../model/teamlid.model';
import { RolLabelPipe } from '../../../shared/pipes/rol-label.pipe';
import { ProfielDetailsGeverifieerdCardComponent } from '../../../profiel/component/profiel-details-geverifieerd-card/profiel-details-geverifieerd-card.component';

@Component({
  selector: 'parkour-uitnodiging-bevestigd-detail',
  templateUrl: './uitnodiging-bevestigd.component.html',
  standalone: true,
  imports: [
    AsyncPipe,
    ProfielDetailsComponent,
    RolLabelPipe,
    ProfielDetailsGeverifieerdCardComponent,
  ],
})
export class UitnodigingBevestigdComponent implements OnChanges {
  @Input({ required: true }) uitnodiging!: UitnodigingDto;

  profiel$ = new Observable<TeamlidProfiel>();

  constructor(private readonly teamService: TeamService) {}

  ngOnChanges(): void {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.profiel$ = this.teamService.getTeamlidInCurrentContext(this.uitnodiging.profielId!);
  }
}
